<template>
  <div class="activity">
    <router-link :to="userUrl"
      class="activity__picture rounded-circle embed-responsive embed-responsive-1by1"
    >
      <img
      :src="timelineActivity.image"
      class="embed-responsive-item"
      />
    </router-link>

    <router-link :to="activityUrl" class="activity__body">
      <p
        class="activity__content"
        v-html="timelineActivity.message"
      >
      </p>
    </router-link>
  </div>
</template>

<script>
  export default {
    props: {
      timelineActivity: { type: Object, default: () => ({}) },
    },

    computed: {
      activityUrl () {
        return this.timelineActivity.activity_url || '#'
      },

      userUrl () {
        return this.timelineActivity.user_url || '#'
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .activity {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &__picture {
      flex-basis: 55px;
      margin-right: 10px;

      .embed-responsive-item {
        background-color: lighten(#000, 85%);
      }
    }

    &__body {
      flex-basis: calc(100% - 66px);
      padding: 8px 16px;
      border-radius: 8px;
      background-color: $purple700;
    }

    &__content {

      &::v-deep .hl { color: $highlightPrimaryColor }
    }
  }
</style>